import { Link } from '@tanstack/react-router';
import { Badge } from '@/shared/ui/badge';
import { Button } from '@/shared/ui/button';

export const NotFoundPage = () => (
  <main className="grid min-h-screen place-items-center bg-[#0f172a] px-6 py-12 text-slate-200">
    <section className="w-full max-w-xl space-y-4 rounded-[1.5rem] border border-slate-500/25 bg-slate-900/70 p-10 text-center shadow-[inset_0_1px_0_rgba(148,163,184,0.15),0_45px_100px_rgba(5,25,45,0.4)] backdrop-blur-xl">
      <Badge
        variant="accent"
        className="mx-auto flex h-12 w-12 items-center justify-center rounded-full text-base font-bold uppercase tracking-tight text-amber-300"
      >
        404
      </Badge>
      <h1 className="text-3xl font-semibold text-slate-100 sm:text-[2.3rem]">
        We could not find that page.
      </h1>
      <p className="text-base leading-relaxed text-slate-300/80">
        The resource you are looking for might have been removed, renamed, or
        is temporarily unavailable.
      </p>
      <Button
        asChild
        variant="glow"
        size="lg"
        className="mt-3 hover:-translate-y-0.5 transition-transform"
      >
        <Link to="/">Go back home</Link>
      </Button>
    </section>
  </main>
);
